// angular
// 	.module("HeroPRO")
// 	.controller("ContractorUserLicenseRegistrationController", contractorUserLicenseRegistrationController);

import _ from 'lodash';

import './contractorUserLicenseRegistration.scss';

/* @ngInject */
export default function contractorUserLicenseRegistrationController($uibModalInstance, selectedUser, AccountsFactory) {
    const vm = this;

    vm.contractorUserLicense;
    vm.confirmCheckBoxValue;
    vm.showCheckSpinner;
    vm.showAddSpinner;
    vm.contractorUserLicenseResponse;
    vm.contractorUserLicenseResponseValid;
    vm.validateContractorUserLicenseClicked;
    vm.contractorUserLicenseErrorMessage;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closeModal = function () {
        $uibModalInstance.close();
    };

    vm.validateContractorUserLicense = function () {
        vm.validateContractorUserLicenseClicked = true;
        if (vm.contractorUserLicenseRegistrationForm.$valid) {
            vm.showCheckSpinner = true;
            AccountsFactory.validateContractorUserLicenseLicense({ "LicenseNumber": vm.contractorUserLicense, "PersonIdentityLicenseTypeId": 1 }).then((response) => {
                vm.contractorUserLicenseResponse = response.data.Data;
                vm.contractorUserLicenseResponseValid = vm.contractorUserLicenseResponse.Status === 1;
                switch (vm.contractorUserLicenseResponse.Status) {
                    case 1:
                        break;
                    case 3:
                        vm.contractorUserLicenseErrorMessage = ': Already registered'; // Duplicate license
                        break;
                    case 4:
                        vm.contractorUserLicenseErrorMessage = ': Expired';
                        break;
                    default:
                        vm.contractorUserLicenseErrorMessage = vm.contractorUserLicenseResponse.Metadata !== undefined ? ': ' + vm.contractorUserLicenseResponse.Metadata.Status : ': Not found';
                        break;
                }

                vm.showCheckSpinner = false;
            });
        }
    };

    vm.addContractorUserLicense = function () {
        if (vm.isFormValid) {
            const license = {
                LicenseTypeId: 1,
                LicenseNumber: vm.contractorUserLicense,
                ExpireDate: vm.contractorUserLicenseResponse.Metadata.ExpireDate,
                IssueDate: vm.contractorUserLicenseResponse.Metadata.IssueDate,
                Status: vm.contractorUserLicenseResponse.Metadata.Status
            };
            if (selectedUser !== undefined) {
                vm.showAddSpinner = true;
                const licenses = new Array();
                licenses.push(license);
                const user = {
                    ContractorUserId: selectedUser.ContractorUserId,
                    Email: selectedUser.Email,
                    PhoneNumber: selectedUser.Phone,
                    Extension: selectedUser.PhoneExt === undefined ? null : selectedUser.PhoneExt,
                    MobilePhone: selectedUser.MobilePhone === undefined ? null : selectedUser.MobilePhone,
                    RoleId: selectedUser.Roles[0].RoleId,
                    Licenses: licenses
                };
                AccountsFactory.updateContractorUser(user).then((userResponse) => {
                    $uibModalInstance.close(userResponse.data.Data)
                });
            }
            else {
                $uibModalInstance.close(license);
            }
        }
    };

    vm.confirmCheckBoxClicked = function () {
        vm.confirmCheckBoxValue = !vm.confirmCheckBoxValue;
    };

    vm.isFormValid = function () {
        return vm.contractorUserLicenseRegistrationForm.$valid && vm.contractorUserLicenseResponseValid && vm.confirmCheckBoxValue;
    }

    vm.clearContractorUserLicenseData = function () {
        clearContractorUserLicenseData();
    }

    /*= =======================================
    =            Private Functions           =
    ======================================== */

    function init() {
        vm.confirmCheckBoxValue = false;
        vm.showCheckSpinner = false;
        vm.showAddSpinner = false;
        vm.contractorUserLicenseResponse = null;
        vm.contractorUserLicenseResponseValid = false;
        vm.validateContractorUserLicenseClicked = false;
        vm.contractorUserLicenseErrorMessage = undefined;
    }

    function clearContractorUserLicenseData() {
        vm.confirmCheckBoxValue = false;
        vm.showCheckSpinner = false;
        vm.showAddSpinner = false;
        vm.contractorUserLicenseResponse = null;
        vm.contractorUserLicenseResponseValid = false;
        vm.contractorUserLicenseErrorMessage = undefined;
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicenseRegistration.js